import { apiGet } from './index'

// 获取旅程
const getJourneyList = (params) => apiGet('/api/journeys/growthjourneyList', params)

// 获取旅程下的所有阶段
const getStageList = (params) => apiGet(`/api/journeys/${params.journeyId}`, params)

// 获取旅程报告内容
const getJourneyReport = (params) => apiGet(`/api/hcp/journey/reports/report/detail/multicode/${params.multiCode}`)

export {
  getJourneyList,
  getStageList,
  getJourneyReport
}



// WEBPACK FOOTER //
// ./src/api/growthJourney.js